/**
 * Стан мережі для оболонки й форм (UX-29): події браузера `online` / `offline` і факти з
 * `platform/network.ts` (запит не дійшов, перевірка теж) — банер «Немає зв'язку», вимкнене збереження.
 */
import { useSyncExternalStore } from 'react';
import { isOnline, subscribeNetwork } from '../platform/network.ts';

function subscribeOnline(cb: () => void) {
  window.addEventListener('online', cb);
  window.addEventListener('offline', cb);
  const off = subscribeNetwork(cb);
  return () => {
    window.removeEventListener('online', cb);
    window.removeEventListener('offline', cb);
    off();
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(subscribeOnline, isOnline, () => true);
}
